export class ExternalView {}
